import { useTranslation } from "react-i18next";
import { Autocomplete, AutocompleteProps, TextField } from "@mui/material";
import { useField } from "formik";
import { useCallback } from "react";

interface FormAutocompleteProps extends Omit<AutocompleteProps<any, boolean | undefined, boolean | undefined, any>, "renderInput"> {
    name: string,
    label: string,
    required?: boolean,
    helperText?: any,
    onChangeValue?: any
}

const FormAutocomplete = ({
    name,
    label,
    required,
    helperText,
    onChangeValue,
    ...props
}: FormAutocompleteProps) => {
    const {t} = useTranslation(['network', 'translation']);
    
    // Use Field
    const [field, meta, helpers] = useField(name);

    // Use Callback
    const getHelperText = useCallback(() => {
        if (typeof helperText === "function")
            return helperText(field.value);
        return helperText;
    }, [helperText]);

    return (
        <Autocomplete
            {...props}
            openOnFocus
            autoHighlight
            autoSelect
            value={field.value}
            onChange={(e, value) => {
                helpers.setValue(value);

                if (!!onChangeValue) {
                    onChangeValue(e, value);
                }
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={label}
                    error={!!meta.error}
                    size="small"
                    fullWidth
                    variant="standard"
                    FormHelperTextProps={{
                        component: "div"
                    } as any}
                    helperText={t((meta.error || getHelperText()) as string)}
                    required={required}
                />
            }
        />
    )
}

export default FormAutocomplete;
